import React from "react";
import { ChangeSubscriptionPlanLoaderTemplate } from "themes/application/payment/components";

function ChangeSubscriptionPlanLoader(props) {
    return <ChangeSubscriptionPlanLoaderTemplate {...props} />;
}

export default ChangeSubscriptionPlanLoader;
